export const alphabetizeByProperty = (array: any, property: string) =>
  array?.sort((a: any, b: any) => a[property]?.localeCompare(b[property]));
